import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import { useLanguage } from "@/hooks/useLanguage";

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <Header />
      <div className="min-h-screen flex items-center justify-center bg-background pt-20 px-4">
        <div className="text-center max-w-md mx-auto">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-light mb-4 text-foreground">{t("notFound.title")}</h1>
          <p className="text-sm sm:text-base md:text-lg text-muted-foreground mb-6 leading-relaxed">{t("notFound.message")}</p>
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-2 bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg transition-all duration-300 font-medium">
            {t("notFound.back")}
          </Link>
        </div>
      </div>
      <Footer />
      <ScrollToTop />
    </>
  );
};

export default NotFound;
